<ax-date-property-edit
  [showIcon]="false"
  [form]="birthdayForm"
  name="register birthday"
  [required]="true"
  [maxDate]="MAX_DATE"
></ax-date-property-edit>

<ax-step-switch (continue)="_continue()" (back)="_back()"></ax-step-switch>
